document
    .querySelectorAll(
        '.collection #ProductGridContainer .productThumbnail .swiper'
    )
    .forEach((slider) => {
        new Swiper(slider, {
            slidesPerView: 1,
            speed: 800,
            spaceBetween: 0,
            loop: true,
            allowTouchMove: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                961: {
                    allowTouchMove: false,
                },
            },
        });
    });
